import React, { useEffect, FC, memo, SetStateAction, Dispatch } from 'react';
import _ from 'lodash';
import moment from 'moment';
import styles from './index.module.scss';

interface ITimeLine {
  onChange: Dispatch<SetStateAction<string[]>>;
  timeLine?: string[];
  cellSize: 'S' | 'L';
}
const TimeLine: FC<ITimeLine> = ({ onChange, timeLine }) => {
  useEffect(() => {
    if (_.isEmpty(timeLine)) {
      const startTime = moment().startOf('day');
      const times = 48 * 2; /* 24 * 2 show only am */
      const TimeArray: string[] = [];
      for (let i = 0; i < times; i += 1) {
        TimeArray.push(
          moment(startTime)
            .add(15 * i, 'minutes')
            .format('h:mm a')
        );
      }
      onChange(TimeArray);
    }
  }, [onChange, timeLine]);

  return (
    <div className={styles.hours}>
      {!_.isEmpty(timeLine) &&
        timeLine?.map(
          (time: string, idx: number) =>
            idx % 2 === 0 && <span key={time}>{`${time}`}</span>
        )}
    </div>
  );
};

export default memo(TimeLine);
